import { Category } from '../types';

const CATEGORY_ALIASES: Record<string, Category> = {
  // New system canonical ids
  [Category.MODELS]: Category.MODELS,
  [Category.PROJECTS]: Category.PROJECTS,
  [Category.PLATFORMS]: Category.PLATFORMS,
  [Category.CONTENT]: Category.CONTENT,
  [Category.COMMUNITY]: Category.COMMUNITY,
  [Category.OTHER]: Category.OTHER,

  // Legacy system canonical ids
  open_source: Category.PROJECTS,
  llm: Category.MODELS,
  articles: Category.CONTENT,
  tools: Category.PLATFORMS,

  // Legacy display names / common variants (lowercase match)
  'open source': Category.PROJECTS,
  llms: Category.MODELS,
  'articles & blogs': Category.CONTENT,
  'dev tools': Category.PLATFORMS,
  dev_tools: Category.PLATFORMS,
  communities: Category.COMMUNITY,
};

export function normalizeResourceCategoryId(input: unknown): Category {
  if (typeof input !== 'string') return Category.OTHER;

  const raw = input.trim();
  if (!raw) return Category.OTHER;

  const lower = raw.toLowerCase();
  const key = lower.replace(/[\s-]+/g, '_');

  // "all" is for filtering only, should not be stored in resource records
  if (key === Category.ALL) return Category.OTHER;

  const mapped = CATEGORY_ALIASES[raw] ?? CATEGORY_ALIASES[lower] ?? CATEGORY_ALIASES[key];
  if (mapped) return mapped;

  if (Object.values(Category).includes(lower as Category)) {
    return lower as Category;
  }

  return Category.OTHER;
}

export function normalizeCategoryFilterParam(input: unknown): Category {
  if (typeof input !== 'string') return Category.ALL;

  const raw = input.trim();
  if (!raw) return Category.ALL;

  const lower = raw.toLowerCase();
  if (lower === Category.ALL) return Category.ALL;

  const normalized = normalizeResourceCategoryId(raw);

  // Unknown category in URL should not accidentally filter to "other", fallback to "all"
  if (normalized === Category.OTHER && lower !== Category.OTHER) {
    return Category.ALL;
  }

  return normalized;
}
